import { Button, Popover } from "antd";
const PreventivoHelper = (props) => (
  <Popover content={props.content} title={props.title}>
    {props.children}
  </Popover>
);
export default PreventivoHelper;
